import constants from '../constants';
import Contact from '../Model/models/contactModel';
import authAxios from '../authorization/axios';

export class ContactsService {

  async getContactsByEmail(mail: string) {
    const result = await authAxios.get<{ data: Contact[] }>(constants.api.searchContacts.replace('{email}', encodeURIComponent(mail)));
    return result.data?.data;
  }

}